import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import BannerList from "../../component/Banner/BannerList";
import BannerMobileList from "../../component/Banner/BannerMobileList";
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup, editBanner } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";
import "./ManageBanners.css";
import BannerForm from "../../component/Banner/BannerForm.js";

function BannersPage() {
  const [action, setAction] = useState(null);
  const edit = useSelector((state) => state?.admin?.edit); 
  const bannerSaving = useSelector((state) => Boolean(state?.admin?.bannerSaving));
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const addBannerAction = () => {
    dispatch(editBanner({ bannerId: '', bannerImage: '', bannerName: '' }));
    setAction("add-banner");
    dispatch(openGlobalPopup("add-banner"));
  };

  const editBannerTitle = () => {
    setAction("edit-banner");
    dispatch(openGlobalPopup("edit-banner"));
  };
  
  const closePopUp = () => {
    dispatch(editBanner({ bannerId: '', bannerImage: '', bannerName: '' })); 
    setAction(null);
  };

  return (
    <div className="container">
      <h1>Manage Banners</h1>

      <button className="add-button ui-page-add-button" onClick={addBannerAction}>
        Add Banner
      </button>

      {/* Renders the Add/Edit form layout safely */}
      <GlobalPopup
        popupKey={action}
        title={edit?.bannerId ? 'Edit Banner' : 'Add Banner'}
        onClose={closePopUp}
        disableClose={bannerSaving}
        footer={(closePopup) => (
          <>
            <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={bannerSaving}>Cancel</button>
            <button type="submit" form="banner-form" className="popup-action-btn" disabled={bannerSaving} aria-busy={bannerSaving}>
              {bannerSaving ? <><span className="popup-button-spinner" aria-hidden="true" />Saving...</> : edit?.bannerId ? 'Save Changes' : 'Publish Banner'}
            </button>
          </>
        )}
      >
        <BannerForm />
      </GlobalPopup>

      <section className="list-section">
        {isMobile ? (
          <BannerMobileList onEdit={editBannerTitle} />
        ) : (
          <BannerList onEdit={editBannerTitle} />
        )}
      </section>
    </div>
  );
}

export default BannersPage;
